import { Injectable, inject } from '@angular/core';
import { Firestore, collection, deleteDoc, doc, docData, setDoc, updateDoc } from '@angular/fire/firestore';
import { Functions, httpsCallable } from '@angular/fire/functions';

import { NetworkConstants } from 'na-lib';
import { newWorkFlowTemplate } from 'na-lib'

import { SettingsService } from './settings.service';
import { FirestoreService } from './firestore.service';
import { map } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class WorkflowTemplatesService {
  db = inject(Firestore)

  constructor(
    private settingsService: SettingsService,
    private firestore: FirestoreService,
    private functions: Functions,
  ) { }

  async createWorkflowTemplate(data: any): Promise<string> {
    return new Promise(async (resolve, reject) => {
      const docRef = doc(
        collection(
          this.db,
          NetworkConstants.COLLECTION_CONTEXTS,
          this.settingsService.contextId$,
          NetworkConstants.COLLECTION_WORKFLOW_TEMPLATES
        )
      );
      const newId = docRef.id;

      const newWorkft = newWorkFlowTemplate;
      newWorkft['id'] = newId;
      newWorkft['creationDate'] = new Date();
      newWorkft['timeStamp'] = new Date();
      if(data['name'])
        newWorkft['name'] = data.name;
      if(data['description'])
        newWorkft['description'] = data.description;
      if(data['trigger'])
        newWorkft['trigger'] = data.trigger;

      try {
        await setDoc(docRef, newWorkft);
        resolve(newId);
      } catch (error) {
        reject(error);
      }
    });
  }

  updateWorkflowTemplate(workflowTemplate: any, id: string): Promise<void> {
    return new Promise(async (resolve, reject) => {
      if (!workflowTemplate['identifier']) {
        workflowTemplate['identifier'] = id;
      }
      try {
        workflowTemplate['timeStamp'] = new Date();
        const docRef = doc(
          this.db,
          NetworkConstants.COLLECTION_CONTEXTS,
          this.settingsService.contextId$,
          NetworkConstants.COLLECTION_WORKFLOW_TEMPLATES,
          workflowTemplate.identifier || id
        );
        await updateDoc(docRef, workflowTemplate);
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  deleteWorkflowTemplate(workflowTemplateId: string): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        const docRef = doc(
          this.db,
          NetworkConstants.COLLECTION_CONTEXTS,
          this.settingsService.contextId$,
          NetworkConstants.COLLECTION_WORKFLOW_TEMPLATES,
          workflowTemplateId
        );
        await deleteDoc(docRef);
        resolve();
      } catch (error) {
        reject(error);
        console.log(error);
      }
    });
  }

  async getWorkflowTypes(): Promise<{ triggers: any[], tasks: any[] }> {
    return new Promise((resolve, reject) => {
      const getWorkflowTypes = httpsCallable(this.functions, 'workflow-getWorkflowTasks');
      getWorkflowTypes()
        .then((result) => {
          const data = result.data as any;
          resolve({
            triggers: data.triggers || [],
            tasks: data.tasks || []
          });
        })
        .catch((error) => {
          console.error('Error loading workflow types:', error);
          reject(error);
        });
    });
  }

  observeContextsWorkflowTemplatesFirestore(workflowTemplateId: string) {

    const docRef = doc(this.db, `${NetworkConstants.COLLECTION_CONTEXTS}/${this.settingsService.contextId$}/${NetworkConstants.COLLECTION_WORKFLOW_TEMPLATES}/${workflowTemplateId}`);

    return docData<any>(docRef).pipe(
      map(content => {
        if (!content) return null;
        return { identifier: workflowTemplateId, ...content };
      })
    );
  }
}
